module.exports = __webpack_public_path__ + "img/GarageOutlined.d2095162.svg";